import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Provider } from 'react-redux';
import { store } from './duck';
import { BuilderContainer } from './containers';

export default class ContractBuilder extends Component {
  render() {

    return (
      <Provider store={store}>
        <BuilderContainer
          contractId={this.props.id}
          onClose={this.props.onClose}
        />
      </Provider>
    );
  }
}
